import CustomAPIFunction from "@views/thinking-layout-editor/CustomAPIFunction";
import { CreatorUtil } from "./CreatorUtil";
import { useHomeServices } from "../useHomeServices";

export function CreatorCustomAPIFunction(): JSX.Element {
  const homeService = useHomeServices();

  return (
    <CustomAPIFunction sendRequest={homeService.sendRequest} evaluateFinalBodyStr={CreatorUtil.evaluateFinalBodyStr} />
  );
}
